import { FC, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useGetOne, FormDataConsumer } from 'react-admin'
import { MunicipalityOut } from '../../../../types/apiRequests'

const PrefillContactFromMunicipality: FC = () => (
  <FormDataConsumer>
    {({ formData }: { formData: { municipalityId?: string } }) => {
      if (!formData.municipalityId) {
        return null
      }
      return <PrefillContactFields municipalityId={formData.municipalityId} />
    }}
  </FormDataConsumer>
)

const PrefillContactFields: FC<{ municipalityId: string }> = ({ municipalityId }) => {
  const { setValue } = useFormContext()

  const { data: municipality, isLoading } = useGetOne<MunicipalityOut>(
    'municipality',
    { id: municipalityId }
  )

  useEffect(() => {
    if (isLoading || !municipality) return

    const timeout = setTimeout(() => {
      setValue('contactNaam', municipality.contactNaam ?? '')
      setValue('contactEmail', municipality.contactEmail ?? '')
      setValue('contactTelefoon', municipality.contactTelefoon ?? '')
    }, 100)

    return () => clearTimeout(timeout)
  }, [municipality, isLoading, setValue])

  return null
}

export default PrefillContactFromMunicipality